import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import FacebookIcon from '../../images/icons/facebook.svg'
import LinkedInIcon from '../../images/icons/linkedin.svg'
import TwitterIcon from '../../images/icons/twitter.svg'
import FileIcon from '../../images/icons/file.svg'
import CloseBtn from '../../images/icons/close-modal.svg'
import ContentType from '../../enums/ContentType'

import {
  StyledCloseBtn,
  StyledFacebookShareButton,
  StyledIconSubtitle,
  StyledLinkContainer,
  StyledLinkedinShareButton,
  StyledOverlay,
  StyledOverlayContainer,
  StyledOverlayCopyIcon,
  StyledOverlayH3,
  StyledOverlayIconLink,
  StyledOverlayIcons,
  StyledOverlayLink,
  StyledOverlayLinkBlock,
  StyledOverlayLinkFooter,
  StyledOverlayLinkMessage,
  StyledOverlaySubtitle,
  StyledOverlayText,
  StyledOverlayTitle,
  StyledTwitterShareButton,
} from './ShareOverlay.styled'

let currentUrl
if (typeof window !== 'undefined') {
  currentUrl = window.location.href
}
const SHARE_LINK_TITLE = `Or share with link`
const COPIED_MESSAGE = `Copied`
const ESCAPE_KEY = 'Escape'
const KEYDOWN = 'keydown'
const CLIPBOARD_WRITE = 'clipboard-write'
const GRANTED_MESSAGE = 'granted'
const FACEBOOK_SUBTITLE = 'Facebook'
const LINKEDIN_SUBTITLE = 'LinkedIn'
const TWITTER_SUBTITLE = 'Twitter'

const shareOverlayTitleMatcher = {
  [ContentType.article]: 'Share This Article',
  [ContentType.templatePageStory]: 'Share This Story',
}

const ShareOverlay = (props) => {
  const { className, title, setIsSharing, contentType, slug } = props
  const [isCopied, setIsCopied] = useState(false)
  const PAGE_TITLE =
    shareOverlayTitleMatcher[contentType] || 'Share This Job Opportunity'

  useEffect(() => {
    if (isCopied) {
      setTimeout(() => setIsCopied(false), 1000)
    }
  }, [isCopied])

  const closeOverlay = (e) => {
    if (e.key === ESCAPE_KEY) return setIsSharing(false)
  }

  useEffect(() => {
    window.addEventListener(KEYDOWN, (e) => closeOverlay(e))
    return window.removeEventListener(KEYDOWN, (e) => closeOverlay(e))
  }, [])

  const copyToClipboard = (str) => {
    navigator.permissions
      .query({
        name: CLIPBOARD_WRITE,
      })
      .then((result) => {
        if (result.state === GRANTED_MESSAGE) {
          navigator.clipboard.writeText(str).then(() => {
            setIsCopied(true)
          })
        }
      })
  }

  const url = `${currentUrl}/${slug}`

  return (
    <StyledOverlay className={className}>
      <StyledOverlayContainer>
        <StyledCloseBtn onClick={() => setIsSharing(false)}>
          <CloseBtn />
        </StyledCloseBtn>
        <StyledOverlayTitle>
          <StyledOverlayH3>{PAGE_TITLE}</StyledOverlayH3>
          <StyledOverlaySubtitle>{title}</StyledOverlaySubtitle>
        </StyledOverlayTitle>
        <StyledOverlayIcons>
          <StyledLinkContainer>
            <StyledOverlayIconLink>
              <StyledLinkedinShareButton url={url}>
                <LinkedInIcon />
              </StyledLinkedinShareButton>
            </StyledOverlayIconLink>
            <StyledIconSubtitle>{LINKEDIN_SUBTITLE}</StyledIconSubtitle>
          </StyledLinkContainer>
          <StyledLinkContainer>
            <StyledOverlayIconLink>
              <StyledTwitterShareButton url={url}>
                <TwitterIcon />
              </StyledTwitterShareButton>
            </StyledOverlayIconLink>
            <StyledIconSubtitle>{TWITTER_SUBTITLE}</StyledIconSubtitle>
          </StyledLinkContainer>
          <StyledLinkContainer>
            <StyledOverlayIconLink>
              <StyledFacebookShareButton url={url}>
                <FacebookIcon />
              </StyledFacebookShareButton>
            </StyledOverlayIconLink>
            <StyledIconSubtitle>{FACEBOOK_SUBTITLE}</StyledIconSubtitle>
          </StyledLinkContainer>
        </StyledOverlayIcons>
        <StyledOverlayLinkFooter>
          <StyledOverlayText>{SHARE_LINK_TITLE}</StyledOverlayText>
          <StyledOverlayLinkBlock onClick={() => copyToClipboard(url)}>
            {isCopied && (
              <StyledOverlayLinkMessage>
                {COPIED_MESSAGE}
              </StyledOverlayLinkMessage>
            )}
            <StyledOverlayLink>{url}</StyledOverlayLink>
            <StyledOverlayCopyIcon>
              <FileIcon />
            </StyledOverlayCopyIcon>
          </StyledOverlayLinkBlock>
        </StyledOverlayLinkFooter>
      </StyledOverlayContainer>
    </StyledOverlay>
  )
}

export default ShareOverlay

ShareOverlay.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  setIsSharing: PropTypes.func.isRequired,
  slug: PropTypes.string,
}

ShareOverlay.defaultProps = {
  slug: '',
}
